<template>
  <el-input
    ref="input"
    class="search-input"
    :value="value"
    @input="(v) => {$emit('input', v); $emit('changeVal', v)}"
    @keyup.enter.native="$emit('search')"
    clearable
    v-bind="attrs">
    <template slot="prepend" v-if="attrs.prependText">{{ attrs.prependText }}</template>
    <template slot="append" v-if="attrs.appendText">{{ attrs.appendText }}</template>
    <span v-if="attrs.isDialog" slot="append" @click="appendClick">
      <i class="el-icon-more" />
      <SearchInputDialog ref="dialog" v-if="attrs.isDialog" :desText="attrs.dialogDesText" :label="attrs.label" :maxCount="attrs.maxCount" />
    </span>
  </el-input>
</template>

<script>
import SearchInputDialog from './SearchInputDialog.vue';
export default {
  name: 'search-input',
  components: {
    SearchInputDialog
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: [String, Number],
    attrs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    appendClick() {
      if(this.attrs.isDialog) {
        this.$refs.dialog.method_open(this.value, this.updateValue)
      } else {
        this.$emit('search')
      }
    },
    updateValue(v) {
      this.$emit('input', v)
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-input {
  width: 230px;

  & ::v-deep .el-input-group__append {
    padding-left: 8.5px;
    padding-right: 8.5px;
  } 
}
</style>